import { useQuery } from '@tanstack/react-query';

import { ContentDto } from '@cineamo/api/models/content/ContentDto.types';

import { getContentById } from '@/utils/api/content/content-api';

export function useContent(contentId: ContentDto['id']): ContentDto | undefined {
    const { data } = useQuery<ContentDto | null>({
        queryKey: [`content-${contentId}`],
        queryFn: async () => {
            return await getContentById(contentId);
        },
        enabled: !!contentId
    });
    return data ?? undefined;
}
